import React from 'react';

const WarrantyPeriod = React.lazy(() => import('pages/WarrantyPeriod/pages/WarrantyPeriod'));
const WarrantyPeriodAdd = React.lazy(() => import('pages/WarrantyPeriod/pages/WarrantyPeriodAddPage'));

const WarrantyPeriodRoutes = [
  {
    path: '/warranty-period',
    exact: true,
    name: 'Danh sách thời hạn bảo hành',
    function: 'SL_WARRANTYPERIOD_VIEW',
    component: WarrantyPeriod,
  },
  {
    path: '/warranty-period/add',
    exact: true,
    name: 'Thêm mới thời hạn bảo hành',
    function: 'SL_WARRANTYPERIOD_ADD',
    component: WarrantyPeriodAdd,
  },
  {
    path: '/warranty-period/edit/:period_id',
    exact: true,
    name: 'Chỉnh sửa thời hạn bảo hành',
    function: 'SL_WARRANTYPERIOD_EDIT',
    component: WarrantyPeriodAdd,
  },
  {
    path: '/warranty-period/detail/:period_id',
    exact: true,
    name: 'Chi tiết thời hạn bảo hành',
    function: 'SL_WARRANTYPERIOD_DETAIL',
    component: WarrantyPeriodAdd,
  },
];

export default WarrantyPeriodRoutes;
